export default __webpack_public_path__ + "static/media/bronze.f0011902.svg";